var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M31.57,72.71c0.19-1.19,0.42-2.69,0.67-4.18c0.59-3.59,1.19-7.17,1.76-10.76c0.04-0.26-0.13-0.63-0.33-0.83 c-3.3-3.41-6.62-6.79-9.93-10.19c-1.03-1.06-1.44-2.3-1.11-3.76c0.36-1.57,1.63-2.73,3.22-2.97c4.62-0.7,9.25-1.41,13.87-2.09 c0.41-0.06,0.58-0.28,0.73-0.62c2-4.31,4.01-8.63,6.02-12.93c0.88-1.89,2.64-2.77,4.5-2.27c1.23,0.33,2.03,1.16,2.56,2.29 c2.03,4.32,4.07,8.64,6.09,12.97c0.17,0.37,0.37,0.54,0.8,0.61c4.53,0.66,9.05,1.35,13.57,2.03c1.57,0.23,2.69,1.05,3.23,2.55 c0.55,1.55,0.22,2.95-0.92,4.13c-3.32,3.42-6.65,6.82-10,10.21c-0.31,0.31-0.38,0.6-0.31,1.03c0.81,4.81,1.61,9.63,2.37,14.45 c0.26,1.61-0.26,2.97-1.63,3.9c-1.35,0.92-2.74,0.86-4.16,0.07c-4.03-2.24-8.08-4.45-12.12-6.69c-0.41-0.23-0.7-0.22-1.11,0.01 c-4.02,2.27-8.04,4.53-12.08,6.75C34.6,77.89,31.53,76.04,31.57,72.71z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreePlay);
export default __webpack_public_path__ + "static/media/free_play.b829105de9c0ebd3311749f1657d0b98.svg";
export { ForwardRef as ReactComponent };